var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.546,
    height: 27.952,
    viewBox: "0 0 25.546 27.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15a0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_47",
    "data-name": "Union 47",
    d: "M8426.244,2974.919a1.6,1.6,0,1,1,2.775-1.61.871.871,0,0,0,1.507,0,1.6,1.6,0,0,1,2.775,1.61,4.08,4.08,0,0,1-7.058,0Zm-7.609-4.151a1.623,1.623,0,0,1-1.572-1.153,1.564,1.564,0,0,1,.67-1.775,6.157,6.157,0,0,0,1.475-2,17.123,17.123,0,0,0,1.536-7.814,9.028,9.028,0,0,1,18.057,0,17.117,17.117,0,0,0,1.538,7.814,6.136,6.136,0,0,0,1.476,2,1.559,1.559,0,0,1,.669,1.775,1.622,1.622,0,0,1-1.574,1.153Zm5.316-12.741a20.025,20.025,0,0,1-2.023,9.533h15.69a20.025,20.025,0,0,1-2.023-9.533,5.822,5.822,0,0,0-11.644,0Z",
    transform: "translate(-8417 -2949)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a0693d49a486e1f37e8c8329b7d3280f.svg";
export { ForwardRef as ReactComponent };